import { ComponentStyleConfig } from '@chakra-ui/theme'

import { textStyles } from '../foundations/typography'

export const Heading: ComponentStyleConfig = {
  sizes: textStyles.headers,
}
